import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { articles } from '@/mocks/articles';

const articleListSchema = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: '新闻动态 - MJHL 最新资讯',
  description: '了解MJHL最新动态、行业趋势、产品发布及品牌故事，掌握前沿科技资讯。',
  url: 'https://mjhl.com/articles',
};

export default function Articles() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleListSchema) }}
      />
      <main className="min-h-screen bg-background-50">
        <div className="pt-20">
          <Breadcrumb items={[{ label: '首页', path: '/' }, { label: '新闻动态' }]} />

          <section className="w-full px-4 md:px-6 py-8 md:py-12">
            <div className="max-w-5xl mx-auto">
              <div className="text-center mb-10">
                <h1 className="text-2xl md:text-4xl font-bold text-foreground-950">
                  新闻动态
                </h1>
                <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
                  了解 MJHL 最新动态、行业趋势与品牌故事
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                {articles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/articles/${article.slug}`}
                    className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
                  >
                    <div className="relative overflow-hidden h-48 md:h-56">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-5 md:p-6">
                      <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                        <span>{article.date}</span>
                        <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                        <span>{article.readTime}</span>
                        <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                        <span>{article.category}</span>
                      </div>
                      <h2 className="text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
                        {article.title}
                      </h2>
                      <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                        {article.excerpt}
                      </p>
                      <div className="mt-4 flex flex-wrap gap-1.5">
                        {article.tags.slice(0, 2).map((tag, i) => (
                          <span
                            key={i}
                            className="px-2.5 py-1 text-xs rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}